import { Form } from "react-bootstrap";
import PropTypes from "prop-types";

function AccessNotes({ accessNotes }) {
  const formattedAccessNotes = accessNotes
    .map((note) => `\u2022 ${note}`)
    .join("\n");

  return (
    <Form.Control
      as="textarea"
      rows={5}
      readOnly
      value={formattedAccessNotes}
      data-testid="access-notes"
    />
  );
}

AccessNotes.defaultProps = {
  accessNotes: [],
};

AccessNotes.propTypes = {
  accessNotes: PropTypes.arrayOf(PropTypes.string),
};

export default AccessNotes;
